const DailyTripsRoutes = {
  getAllTrips: "/rides/allRides",
  getTripDetails: "/rides/tripdetails"
};

export default DailyTripsRoutes